import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {
  NotificationManager,
} from "react-notifications";
import approveRecruiterFromRevoke from "../../apis/recruiters/approveRecruiters";
import "./recruiters.css";
import DataTable from "../../components/DataTable/DataTable";

const AllRevokedRecruitersTable = ({
  allRevokedRecruiters,
  isDataLoaded,
  setPaginationState,
  totalCount,
}) => {
  const [dataResult, setDataResult] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedDataItem, setSelectedDataItem] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [takeNumberOfResult, setTakeNumberOfResult] = useState(10);


  const columns = [
    {
      accessorKey: 'Action',
      header: 'Action',
      enableSorting: false,
      cell: ({ row }) => (
        <Button
          variant="contained"
          color="primary"
          className="unrevokedButton"
          onClick={() => openModal(row.original)}
        >
          UnRevoke
        </Button>
      ),
      size: 150,
    },
    {
      accessorKey: 'firstName',
      header: 'First Name',
      size: 200,
    },
    {
      accessorKey: 'lastName',
      header: 'Last Name',
      size: 200,
    },
    {
      accessorKey: 'email',
      header: 'Email',
      size: 350,
    },
    {
      accessorKey: 'organizationnameduringsignup',
      header: 'Recruitment Organization',
      size: 200,
    },
    {
      accessorKey: 'agencyName',
      header: 'Agency',
      size: 200,
    },
    {
      accessorKey: 'phoneNumber',
      header: 'Phone Number',
      size: 200,
    },
    {
      accessorKey: 'locationCountry',
      header: 'Country',
      size: 200,
    },
  ]

  // Handle page change
  const handlePageChange = (newPage, newPageSize) => {
    setPageNumber(newPage);
    if (newPageSize && newPageSize !== takeNumberOfResult) {
      setTakeNumberOfResult(newPageSize);
    }
    setPaginationState({
      page: newPage,
      pageSize: newPageSize || takeNumberOfResult,
    });
  }

  // Handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setTakeNumberOfResult(newPageSize);
    setPageNumber(1);
    setPaginationState({
      page: 1,
      pageSize: newPageSize,
    });
  };

  const openModal = (dataItem) => {
    setSelectedDataItem(dataItem);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const saveHandler = async () => {
    const payload = {
      userid: selectedDataItem.id,
      unrevoke: true
    };
    let dataResultArr = [...dataResult];

    try {
      const response = await approveRecruiterFromRevoke(payload);
      NotificationManager.success(
        `${response?.data?.message}`,
        "Success",
        10000
      );
      dataResultArr = dataResultArr.filter(item => item.id !== selectedDataItem.id);
      setDataResult(dataResultArr);

    } catch (error) {
      NotificationManager.error(
        `${error?.data?.message || "something went wrong"}`,
        "error",
        10000
      );
    }
    setModalIsOpen(false);
  };

  useEffect(() => {
    let arr = [];
    if (!allRevokedRecruiters || !Array.isArray(allRevokedRecruiters)) {
      arr = [];
    }
    else {
      arr = allRevokedRecruiters.map(recruiter => ({
        ...recruiter,
        agencyName: recruiter.agency?.agencyName || "N/A",
        locationCountry: recruiter?.profile?.locationCountry
          ? JSON.parse(recruiter.profile.locationCountry).name
          : " "
      }));
    }
    setDataResult(arr);
  }, [allRevokedRecruiters]);

  return (
    <>
      <DataTable
        data={dataResult}
        columns={columns}
        isLoading={!isDataLoaded}
        totalRecords={totalCount}
        currentPage={pageNumber}
        pageSize={takeNumberOfResult}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        enableFiltering={false}
        enablePagination={true}
        enableSorting={false}
        pageSizeOptions={[10, 20, 50, 100]}
        isServerSide={true}
        noDataText="No results found !"
      />

      {/* Modal Dialog */}
      <Dialog
        onClose={closeModal}
        open={modalIsOpen}
        aria-labelledby="customized-dialog-title"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogContent>
          <div className="fs-semi-bold f-color fs-18">
            Do you want to UnRevoke this user?
          </div>
        </DialogContent>
        <DialogActions>
          <div className='button_Container_CreateRequisition'>
            <Button
              variant="contained"
              color="primary"
              className="ButtonSave_createRequisition_dialog"
              onClick={saveHandler}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className='ButtonCancel_createRequisition'
              onClick={closeModal}
            >
              No
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AllRevokedRecruitersTable;
